import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { MobileOptimizationProvider } from './utils/mobileOptimization'
import { logger } from './utils/structuredLogging'
import './utils/productionOptimization'

// Expose build version for support and parity checks
declare const __PSYFORGE_COMMIT__: string | undefined;
declare const __PSYFORGE_BUILD_TIME__: string | undefined;

const commitHash = typeof __PSYFORGE_COMMIT__ !== 'undefined' ? __PSYFORGE_COMMIT__ : 'dev';
const buildTime = typeof __PSYFORGE_BUILD_TIME__ !== 'undefined' ? __PSYFORGE_BUILD_TIME__ : new Date().toISOString();

(window as unknown as Record<string, unknown>).__PSYFORGE_VERSION__ = commitHash;
(window as unknown as Record<string, unknown>).__PSYFORGE_BUILD_TIME__ = buildTime;

try {
  document.querySelector('meta[name="psyforge-version"]')?.setAttribute('content', commitHash);
  document.querySelector('meta[name="psyforge-build-time"]')?.setAttribute('content', buildTime);
} catch {
  // ignore meta-tag mutations in constrained environments
}

// Initialize performance monitoring
logger.info('Application starting', {
  component: 'Main',
  action: 'initialize',
  metadata: {
    userAgent: navigator.userAgent,
    viewport: { width: window.innerWidth, height: window.innerHeight }
  }
});

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <MobileOptimizationProvider
      options={{
        enableTouchOptimization: true,
        optimizeImages: true,
      }}
    >
      <App />
    </MobileOptimizationProvider>
  </React.StrictMode>,
)
